/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_BrandInputs */

const en_field_brand = /** @type {(inputs: Field_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand`)
};

const es_field_brand = /** @type {(inputs: Field_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca`)
};

const fr_field_brand = /** @type {(inputs: Field_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque`)
};

const de_field_brand = /** @type {(inputs: Field_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marke`)
};

const ja_field_brand = /** @type {(inputs: Field_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブランド`)
};

const zh_field_brand = /** @type {(inputs: Field_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`品牌`)
};

const ar_field_brand = /** @type {(inputs: Field_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العلامة التجارية`)
};

const id_field_brand = /** @type {(inputs: Field_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merek`)
};

const it_field_brand = /** @type {(inputs: Field_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand`)
};

const ru_field_brand = /** @type {(inputs: Field_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бренд`)
};

const pt_field_brand = /** @type {(inputs: Field_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca`)
};

const ko_field_brand = /** @type {(inputs: Field_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브랜드`)
};

/**
* | output |
* | --- |
* | "Brand" |
*
* @param {Field_BrandInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_brand = /** @type {((inputs?: Field_BrandInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_BrandInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_brand(inputs)
	if (locale === "es") return es_field_brand(inputs)
	if (locale === "fr") return fr_field_brand(inputs)
	if (locale === "de") return de_field_brand(inputs)
	if (locale === "ja") return ja_field_brand(inputs)
	if (locale === "zh") return zh_field_brand(inputs)
	if (locale === "ar") return ar_field_brand(inputs)
	if (locale === "id") return id_field_brand(inputs)
	if (locale === "it") return it_field_brand(inputs)
	if (locale === "ru") return ru_field_brand(inputs)
	if (locale === "pt") return pt_field_brand(inputs)
	return ko_field_brand(inputs)
});